module.exports = "../fonts/IBMPlexSans-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans-Medium.ttf
// module id = 590
// module chunks = 0